import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent
} from '@/components/ui/card';
import LoadingPage from '@/components/common/LoadingPage';

import { useOfferingCategories } from '@/data/offeringCategory';

import OfferingCategoryList from './components/offeringCategoryListPage/OfferingCategoryList';
import AddOfferingCategoryDialog from './AddOfferingCategoryDialog';

const OfferingCategoryListPage = () => {
  const offeringCategories = useOfferingCategories();

  if (offeringCategories.isLoading && !offeringCategories.data) {
    return <LoadingPage />;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex justify-between items-center mb-4">
          Offering Categories <AddOfferingCategoryDialog />
        </CardTitle>
        <CardDescription>
          Manage the offering categories that ProFound supports.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <OfferingCategoryList />
      </CardContent>
    </Card>
  );
};

export default OfferingCategoryListPage;
